import { SET_SEARCH_OBJ } from "../action.js";

export const setSearchObj = (searchObj) => {
  return (dispatch) => {
    dispatch({ type: SET_SEARCH_OBJ, payload: searchObj });
  };
};
